import React from "react";
import styled from "styled-components";

const DividerItem = styled.div`
  border-bottom: 1px solid #ced4da;
  width: 100%;
  padding-top: 16px;
  margin-bottom: 16px;
`;

const Divider = () => <DividerItem />;

export default Divider;
